
import webApi from './webApi'


const invitationService = {
    fetchAll : async(timestamp)=>{
        return await webApi.httpGet('invitations', {timestamp})
    },
    
    fetch : async(id)=>{
        return await webApi.httpGet('invitations/'+id)
    },

    create : async(invitation)=>{
        return await webApi.httpPost('invitations', invitation)
    },
    update : async(invitation)=>{
        return await webApi.httpPut('invitations', invitation)
    },

    delete : async(id)=>{
        return await webApi.httpDelete('invitations/'+id)
         
    },

    cancel : async(action)=>{
        return await webApi.httpPost('invitations/cancel',  action)
         
    },

    hard_delete : async(action)=>{
        return await webApi.httpPost('invitations/hard_delete',  action)
         
    },

    rescheduleOnce : async(action)=>{
        return await webApi.httpPost('invitations/reschedule_once',  action)
         
    },
    rescheduleWholeSeries : async(action)=>{
        return await webApi.httpPost('invitations/reschedule_whole_series',  action)
         
    },


}




export default invitationService